import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function SetupAccountPage() {
  const { refreshUser, user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token');
  const [name, setName] = useState(user?.name || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim()) {
      setError('Please enter your name.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      if (inviteToken) {
        // Invited via an emailed setup link — not logged in yet, so this call
        // authenticates itself with the token and returns a fresh JWT.
        const res = await api.post('/auth/accept-invite', { token: inviteToken, name: name.trim(), newPassword: password });
        localStorage.setItem('match-a_token', res.data.token);
        window.location.href = '/onboarding'; // full reload so AuthContext picks up the new session
        return;
      }
      await api.post('/auth/complete-setup', { name: name.trim(), newPassword: password });
      await refreshUser();
      navigate('/onboarding');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #fafdf5 60%, #dcfce7 100%)',
      padding: 24
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 420, padding: 40 }}>
        <Link to="/" style={{ fontSize: 40, textAlign: 'center', marginBottom: 8, display: 'block', textDecoration: 'none' }}>🍵</Link>
        <h2 style={{ fontSize: 24, textAlign: 'center', marginBottom: 8 }}>Welcome to Matcha!</h2>
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', fontSize: 15, marginBottom: 28 }}>
          {user?.name
            ? 'Confirm your name and choose a permanent password to complete your account setup.'
            : 'Please set your name and choose a permanent password to complete your account setup.'}
        </p>

        {error && (
          <div style={{
            background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
            borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 20
          }}>{error}</div>
        )}

        <form onSubmit={handle} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
              YOUR NAME
            </label>
            <input
              className="input"
              placeholder="Jane Smith"
              value={name}
              onChange={e => setName(e.target.value)}
              required
              autoFocus={!user?.name}
            />
          </div>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
              NEW PASSWORD
            </label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
              autoFocus={!!user?.name}
            />
          </div>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
              CONFIRM PASSWORD
            </label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              minLength={8}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ marginTop: 8, justifyContent: 'center', padding: '12px' }}
            disabled={loading}
          >
            {loading ? 'Saving…' : 'Complete Setup →'}
          </button>
        </form>
      </div>
    </div>
  );
}
